import { notificationsType } from "@/common/const/filter-options";
import { ColumnsStrategy } from "@/common/types";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  TableCellWithTime,
} from "@/components/TableComponents";
import Typography from "@/components/Typography/Typography";

const dashboardNotification: ColumnsStrategy[] = [
  {
    label: <DefaultHeadColumns text="Title" key="title" />,
    name: "tittle",
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn text={value} key={record.id} />
    ),
  },
  {
    label: <DefaultHeadColumns text="Type" key="type" />,
    name: "type",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn
        text={
          notificationsType.find((item) => item.value === value)?.label || ""
        }
        key={record.id}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Created At" key="createdAt" />,
    name: "createdAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: <DefaultHeadColumns text="Due Date" key="dueDate" />,
    name: "dueDate",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: <DefaultHeadColumns text="Description" key="description" />,
    name: "description",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn text={value} key={record.id} />
    ),
  },
];

const preparedNotificationStrategy = dashboardNotification.map((col, index) => {
  if (index === 0) {
    return {
      ...col,
      render: (text: string, record: any) => (
        <div className="flex items-center relative text-nowrap">
          <Typography
            type="span"
            customStyles={`relative left-[-12px] -top-3 -translate-y-1/2 min-w-2 min-h-2 ${record.users[0].isReaded ? "#F5F5F5" : "bg-blue-500"} rounded-full`}
          />
          {text}
        </div>
      ),
    };
  }
  return col;
});

export default preparedNotificationStrategy;
